import { CircularProgress } from "@mui/material";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
	VALIDATOR_EMIAL,
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
	VALIDATOR_VALIDATED,
} from "../../shared/util/validators";

import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { baseUrl } from "../../baseUrl";

const DoctorsForm = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [handler, setHandler] = useState(false);
	const auth = useContext(AuthContext);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const [formState, inputHandler] = useForm(
		{
			doctorName: {
				value: "",
				isValid: false,
			},
			contactNumber: {
				value: "",
				isValid: true,
			},
			email: {
				value: "",
				isValid: true,
			},
			address: {
				value: "",
				isValid: true,
			},
			token: {
				value: "",
				isValid: true,
			},
		},
		false
	);
	const dispatch = useDispatch();

	const doctorSubmitHandler = async (event) => {
		try {
			setIsLoading(true);
			const response = await fetch(
				baseUrl + "/api/v1/laboratorys/add-doctor",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						authorization: auth.token,
					},
					body: JSON.stringify({
						contactNumber: formState.inputs.contactNumber.value,
						address: formState.inputs.address.value,
						email: formState.inputs.email.value,
						name: formState.inputs.doctorName.value,
						doctorToken: formState.inputs.token.value,
					}),
				}
			);
			const responseData = await response.json();
			if (!response.ok) {
				throw new Error(responseData.message);
			} else {
				enqueueSnackbar(responseData.message.message, {
					variant: "success",
				});
			}
			setIsLoading(false);
			dispatch({
				type: "update_doctor_table",
			});
		} catch (err) {
			setIsLoading(false);
			err &&
				err.data.map((error) => {
					enqueueSnackbar(error, { variant: "error" });
				});
		} finally {
			event.preventDefault();
		}
		setHandler(!handler);
	};

	return (
		<React.Fragment>
			<Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2 }}>
				<Typography variant="h5" align="center" sx={{ mb: 5 }}>
					پزشک جدید
				</Typography>
				{isLoading ? (
					<div style={{ justifyContent: "center", display: "flex" }}>
						<CircularProgress color="inherit" />
					</div>
				) : (
					<form onSubmit={doctorSubmitHandler}>
						<Grid container spacing={2}>
							<Grid md={6} xs={12}>
								<Input
									id="doctorName"
									element="input"
									label="نام پزشک"
									validators={[VALIDATOR_REQUIRE()]}
									errorText="لطفا نام پزشک را وارد کنید."
									onInput={inputHandler}
								/>
							</Grid>
							<Grid md={6} xs={12}>
								<Input
									id="contactNumber"
									element="number_only"
									label="شماره تماس"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا شماره تماس پزشک را وارد کنید. مقدار وارد شده باید فقط شامل اعداد باشد."
									onInput={inputHandler}
									inputValid={true}
								/>
							</Grid>
							<Grid md={6} xs={12}>
								<Input
									id="email"
									element="input"
									label="ایمیل"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_EMIAL(),
									]}
									errorText="لطفا ایمیل پزشک را وارد کنید. (فرمت صحیح ایمیل به صورت abc@example.com می‌باشد.)"
									onInput={inputHandler}
									inputValid={true}
								/>
							</Grid>
							<Grid md={6} xs={12}>
								<Input
									id="token"
									element="input"
									label="توکن"
									validators={[VALIDATOR_VALIDATED()]}
									errorText="لطفا توکن پزشک را وارد کنید."
									onInput={inputHandler}
									inputValid={true}
								/>
							</Grid>
							<Grid md={12} xs={12}>
								<Input
									id="address"
									element="input"
									label="آدرس"
									validators={[VALIDATOR_VALIDATED()]}
									errorText="لطفا آدرس پزشک را وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									multiline={true}
								/>
							</Grid>
							<Grid xs={12} sm={12}>
								<Button
									type="submit"
									disabled={!formState.isValid}
									fullWidth
									color="secondary"
									variant="contained"
								>
									ثبت پزشک جدید
								</Button>
							</Grid>
						</Grid>
					</form>
				)}
			</Paper>
		</React.Fragment>
	);
};

export default DoctorsForm;
